import WrapPage from "../components/wrapPage"
import AboutPage from "../aboutPage"

export default WrapPage(AboutPage)
